import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PILLAR_BY_KEY, PILLARS } from '../config/pillars';

const DEFAULT_KEY = 'yield_discovery';

/**
 * Reads / writes `?stack=<key>` from the URL.
 * Validates against PILLAR_BY_KEY; falls back to yield_discovery.
 */
export default function useStackNavigation() {
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get('stack');
  const selected = PILLAR_BY_KEY[raw] ? raw : DEFAULT_KEY;

  const select = useCallback(
    (key) => {
      if (!PILLAR_BY_KEY[key]) return;
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('stack', key);
        return next;
      }, { replace: true });
    },
    [setSearchParams],
  );

  const selectedIndex = PILLARS.findIndex((p) => p.key === selected);

  const selectByOffset = useCallback(
    (offset) => {
      const idx = PILLARS.findIndex((p) => p.key === selected);
      const next = (idx + offset + PILLARS.length) % PILLARS.length;
      select(PILLARS[next].key);
    },
    [selected, select],
  );

  return { selected, select, selectedIndex, selectByOffset };
}
